<template lang="pug">
form.v-details.details(v-if="form" @click.stop @submit.prevent="submit" novalidate autocomplete="off"
		:class="{'details--total-opened': totalOpened, 'details--has-add-options': productData && productData.addOptions}")
	button.details__back-btn.modal-window__close.details__back-btn--visible(v-if="(productData.formDetails || form.formDetails) && !withoutBackArrow" type="button" @click.stop="openFormDetails")
		v-svg-icon.modal-window__back-icon(icon="arrow-back")
		.modal-window__close-text Назад
	v-loader(:loading="loading")
	.details__title(v-if="form.title") {{form.title}}
	.details__main.flc
		.details__fields
			template(v-for="(field, fieldIndex) in form.fields" :key="fieldIndex")
				.details__field.flc
					template(v-if="field.name === 'COUNTRY'")
						v-field(:field="field"
								v-model="countryValue"
								:errors="getFieldError(field)"
								@fileinput="fileInput(field, $event)"
								@fileremove="fileRemove(field, $event)"
								@remove="valueRemove(field, $event)"
								@update:model-value="fieldChanged(field, $event)")
					template(v-else-if="field.name === 'BENEFIT'")
						v-field(:field="field"
								v-model="benefitValue"
								:errors="getFieldError(field)"
								@fileinput="fileInput(field, $event)"
								@fileremove="fileRemove(field, $event)"
								@remove="valueRemove(field, $event)"
								@update:model-value="fieldChanged(field, $event)")
					template(v-else-if="field.name === 'CAR_ENGINE'")
						v-field(:field="field"
								v-model="carEngineValue"
								:errors="getFieldError(field)"
								@fileinput="fileInput(field, $event)"
								@fileremove="fileRemove(field, $event)"
								@remove="valueRemove(field, $event)"
								@update:model-value="fieldChanged(field, $event)")
					template(v-else-if="field.name === 'CAR_AGE'")
						v-field(:field="field"
								v-model="carAgeValue"
								:errors="getFieldError(field)"
								@fileinput="fileInput(field, $event)"
								@fileremove="fileRemove(field, $event)"
								@remove="valueRemove(field, $event)"
								@update:model-value="fieldChanged(field, $event)")
					template(v-else-if="field.name === 'CAR_PRICE' && productPriceValue")
						v-field(:field="field"
								v-model="productPriceValue"
								:errors="getFieldError(field)"
								@fileinput="fileInput(field, $event)"
								@fileremove="fileRemove(field, $event)"
								@remove="valueRemove(field, $event)"
								@update:model-value="fieldChanged(field, $event)")
					template(v-else-if="field.name === 'CAR_PRICE_CUSTOMS' && productPriceCustomsValue")
						v-field(:field="field"
								v-model="productPriceCustomsValue"
								:errors="getFieldError(field)"
								@fileinput="fileInput(field, $event)"
								@fileremove="fileRemove(field, $event)"
								@remove="valueRemove(field, $event)"
								@update:model-value="fieldChanged(field, $event)")
					template(v-else-if="field.name === 'ENGINE_VOLUME' && engineVolumeValue")
						v-field(:field="field"
								v-model="engineVolumeValue"
								:errors="getFieldError(field)"
								@fileinput="fileInput(field, $event)"
								@fileremove="fileRemove(field, $event)"
								@remove="valueRemove(field, $event)"
								@update:model-value="fieldChanged(field, $event)")
					template(v-else)
						v-field(:field="field"
								v-model="field.value"
								:errors="getFieldError(field)"
								@fileinput="fileInput(field, $event)"
								@fileremove="fileRemove(field, $event)"
								@remove="valueRemove(field, $event)"
								@update:model-value="fieldChanged(field, $event)")

		.details__params(v-if="view === 'regular' && productData && productData.options")
			//- Сборы аукциона
			.details__param.flc(v-if="productData.options.auctionFees")
				.details__param-name {{productData.options.auctionFees.name}}
				.details__param-value
					v-price(:price="productData.options.auctionFees.price")
			//- Доставка
			.details__param.flc(v-if="productData.options.delivery")
				.details__param-name {{productData.options.delivery.name}}
				.details__param-value
					v-price(:price="productData.options.delivery.price")
			//- Наши услуги
			.details__param.flc(v-if="productData.options.ourServices")
				.details__param-name {{productData.options.ourServices.name}}
				.details__param-value
					v-price(:price="productData.options.ourServices.price")
			//- Растаможка
			.details__param.flc(v-if="productData.options.customsClearance")
				.details__param-name {{productData.options.customsClearance.name}}
				.details__param-value
					v-price(:price="productData.options.customsClearance.price")

		template(v-if="view === 'regular'")
			.details__calculator-action
				button.details__calculator-btn.btn.btn--block(type="button" @click="openCustomsCalculator")
					v-svg-icon.btn__icon(icon="calculator")
					.btn__text Таможенный калькулятор
	.details__overlay(@click.stop="closeTotal")
	.details__action(v-if="productData && productData.total")
		button.details__back-btn.modal-window__close(v-if="productData.formDetails || form.formDetails" type="button" @click.stop="closeTotal")
			v-svg-icon.modal-window__back-icon(icon="arrow-back")
			.modal-window__close-text Назад
		button.details__close-btn.modal-window__close(type="button" @click.stop="closeTotalandModal")
			.modal-window__close-text Закрыть
			v-svg-icon.modal-window__close-icon(icon="close")
		.details__total(v-if="productData.customsPayments")
			.details__total-name {{productData.customsPayments.name}}
			template(v-if="productData.customsPayments && productData.customsPayments.prices")
				.details__total-price
					v-price(:price="productData.customsPayments.prices[fieldCurrency.value]")
			template(v-else-if="productData.customsPayments && productData.customsPayments.price")
				.details__total-price
					v-price(:price="productData.customsPayments.price")
		.details__total(v-if="productData.total && !totalOpened")
			.details__total-name(v-if="productData.total.name"
					ref="totalText")
				| {{updateTextOverflow}}
			.key-value-list__tooltip-wrapper.details__total-name--tooltip(v-if="tooltip")
				template(v-if="isSm")
					v-svg-icon.key-value-list__tooltip-icon(icon="tooltip-icon"
						@click.stop="openTooltip(textTooltip)")
				template(v-else)
					v-svg-icon.key-value-list__tooltip-icon(icon="tooltip-icon")
					.key-value-list__tooltip-container
						.key-value-list__tooltip
							.key-value-list__tooltip-text.scrollbar(v-if="textTooltip" v-html="textTooltip")
			template(v-if="productData.total && productData.total.prices")
				.details__total-price
					v-price(:price="productData.total.prices[fieldCurrency.value]")
					span.details__total-star(v-if="productData.total.note") *
			template(v-else-if="productData.total && productData.total.price")
				.details__total-price
					v-price(:price="productData.total.price")
		button.details__total-note(v-if="productData.addOptions"
				:class="{'details__total-note--opened': totalOpened}"
				type="button"
				@click="toggleTotal")
			span.details__total-note-text(v-if="totalOpened") Скрыть детали расчета
			span.details__total-note-text(v-else) Показать детали расчета
			v-svg-icon.details__total-note-icon(icon="small-chevron")
		template(v-if="productData.addOptions")
			v-collapse.details__total-collapse(:open="totalOpened")
				.details__total-collapse-inner
					.details__small-params-field
						v-field(:field="fieldCurrency"
								appearance="form"
								v-model="fieldCurrency.value"
								@update:model-value="fieldCurrencyChanged")
						//-1
					.details__small-params.flc(v-if="productData.firstOptions && productData.firstOptions.length")
						template(v-for="(addOption, addOptionIndex) in productData.firstOptions" :key="addOptionIndex")
							.details__small-param.flc
								.details__small-param-name(:class="{'details__small-param-name--bold': addOption.bold}") {{addOption.name}}
								.details__small-param-value
									v-price(:price="addOption.prices[fieldCurrency.value]")
						//-2
					.details__small-params.flc(v-if="productData.addOptions && productData.addOptions.length && productData.addOptions.some((item)=> !item.framed  && item?.name?.toUpperCase() === 'Сборы аукциона'.toUpperCase())")
						template(v-for="(addOption, addOptionIndex) in productData.addOptions.filter((item)=> !item.framed && item?.name?.toUpperCase() === 'Сборы аукциона'.toUpperCase())" :key="addOptionIndex")
							.details__small-param.flc
								.details__small-param-name(:class="{'details__small-param-name--bold': addOption.bold}") {{addOption.name}}
								.details__small-param-value
									v-price(:price="addOption.prices[fieldCurrency.value]")
						//-3
					.details__small-params.details__small-params--framed.details__small-params--first.flc(v-if="productData.addOptions && productData.addOptions.length && productData.addOptions.some((item)=> item.framed)" )
						template(v-for="(addOption, addOptionIndex) in productData.addOptions.filter((item)=> item.framed)" :key="addOptionIndex")
							template(v-for="(item, itemIndex) in addOption.framed" :key="itemIndex")
								.details__small-param.flc
									.details__small-param-name(:class="{'details__small-param-name--bold': item.bold}") {{item.name}}
									.details__small-param-value
										v-price(:price="item.prices[fieldCurrency.value]")
						//-4
					.details__small-params.details__small-params--framed.details__small-params--second.flc(v-if="productData.framed && productData.framed.length")
						template(v-for="(addOption, addOptionIndex) in productData.framed" :key="addOptionIndex")
							.details__small-param.flc
								.details__small-param-name(:class="{'details__small-param-name--bold': addOption.bold}") {{addOption.name}}
								.details__small-param-value
									v-price(:price="addOption.prices[fieldCurrency.value]")
						//-5
					.details__small-params.flc(v-if="productData.addOptions && productData.addOptions.length && productData.addOptions.some((item)=> !item.framed && item?.name?.toUpperCase() !== 'Сборы аукциона'.toUpperCase())")
						template(v-for="(addOption, addOptionIndex) in productData.addOptions.filter((item)=> !item.framed && item?.name?.toUpperCase() !== 'Сборы аукциона'.toUpperCase())" :key="addOptionIndex")
							.details__small-param.flc
								.details__small-param-name(:class="{'details__small-param-name--bold': addOption.bold}") {{addOption.name}}
								.details__small-param-value
									v-price(:price="addOption.prices[fieldCurrency.value]")
					//-Moving total price
					.details__total.details__total--bottom(v-if="productData.total && totalOpened")
						.details__total-name(v-if="productData.total.name" ref="totalTextBottom") {{updateTextOverflow}}
							.key-value-list__tooltip-wrapper.details__total-name--tooltip(v-if="tooltipBottom")
								template(v-if="isSm")
									v-svg-icon.key-value-list__tooltip-icon(icon="tooltip-icon"
										@click.stop="openTooltip(textTooltip)")
								template(v-else)
									v-svg-icon.key-value-list__tooltip-icon(icon="tooltip-icon")
									.key-value-list__tooltip-container
										.key-value-list__tooltip
											.key-value-list__tooltip-text.scrollbar(v-if="textTooltip" v-html="textTooltip" )
						template(v-if="productData.total && productData.total.prices")
							.details__total-price
								v-price(:price="productData.total.prices[fieldCurrency.value]")
								span.details__total-star(v-if="productData.total.note") *
						template(v-else-if="productData.total && productData.total.price")
							.details__total-price
								v-price(:price="productData.total.price")
					.details__note(v-if="productData.total.note") {{productData.total.note}}
		button.details__total-btn.btn.btn--primary.btn--block(type="submit") Получить точный расчет
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from '../scripts/controller/controller';

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	props: {
		mode: {
			type: String,
			default: null
		},

		view: {
			type: String,
			default: 'regular'
		},

		propProductData: {
			type: Object,
			default: null
		},

		withoutBackArrow: {
			type: Boolean,
			default: false
		}
	},

	emits: [
		'success'
	],

	data() {
		return {
			form: null,
			localFormData: new FormData(),
			modalTimeout: null,
			confirmValue: [],
			confirmed: false,
			savedFileKeys: [],
			productPriceValue: {
				"min": 0,
				"max": 999999,
				"selectValue": null
			},
			productPriceCustomsValue: {
				"min": 0,
				"max": 999999,
				"selectValue": null
			},
			engineVolumeValue: {
				"min": 0,
				"max": 5000,
				"selectValue": null
			},
			totalOpened: false,
			currentCurrency: 'USD',
			fieldCurrency: null,
			openModalTimerID: null,
			productData: null,
			countryValue: null,
			carAgeValue: null,
			carEngineValue: null,
			benefitValue: null,
			tooltip: false,
			tooltipBottom: false,
			textTooltip: '',
		};
	},

	mounted() {
		window.addEventListener('resize', this.updateTextOverflow);
	},

	unmounted() {
		window.removeEventListener('resize', this.updateTextOverflow);
	},

	watch: {
		'productData.total.name': {
			immediate: true,
			handler() {
				this.updateTextOverflow();
			}
		},
		totalOpened: {
			immediate: true,
			handler() {
				this.updateTextOverflow();
			}
		}
	},

	computed: {
		computedConfirmField() {
			return {
				type: 'check-list',
				value: [],
				label: null,
				options: [
					{
						'value': '1',
						'text': this.form.requireConfirmText
					}
				]
			};
		},
	},

	methods: {
		updateTextOverflow() {
			this.$nextTick(() => {
				const totalTextElement = this.totalOpened ? this.$refs.totalTextBottom : this.$refs.totalText;
				if (!totalTextElement || !this.productData?.total?.name) return;
				const fullText = this.productData.total.name;
				totalTextElement.textContent = fullText;
				const style = window.getComputedStyle(totalTextElement);
				const lineHeight = parseInt(style.lineHeight, 10) || parseInt(style.fontSize, 10) * 1.2;
				const lines = Math.round(totalTextElement.scrollHeight / lineHeight);
				if (this.productData?.total?.tooltip) {
					this.textTooltip = this.productData?.total?.tooltip
				}
				if (lines > 1) {
					const words = this.productData.total.name.split(/\s+/);
					const firstWord = words[0];
					const restText = words.slice(1).join(' ');
					totalTextElement.textContent = firstWord;
					this.textTooltip = this.productData?.total?.tooltip || restText;
				}
				if (this.textTooltip) {
					if (this.totalOpened) {
						this.tooltipBottom = true
						this.tooltip = false
					} else {
						this.tooltipBottom = false
						this.tooltip = true
					}
				}
				return totalTextElement.textContent
			});
		},

		fieldCurrencyChanged(value) {
			this.localFormData.set('сurrency', value);
			this.submit({action: 'autosubmit'});
		},

		openTooltip(text) {
			controller.openModal({
				className: 'modal--mid',
				content: `<v-modal-window>${text}</v-modal-window>`
			});
		},

		toggleTotal() {
			if (this.totalOpened) {
				this.closeTotal();
			} else {
				this.openTotal();
			}
		},

		openTotal() {
			document.body.classList.add('state--details-open');
			this.totalOpened = true;
		},

		closeTotal() {
			this.totalOpened = false;
			document.body.classList.remove('state--details-open');
		},

		closeTotalandModal() {
			this.closeTotal();
			controller.closeModal();
		},

		openFormDetails() {
			this.closeTotal();
			if (this.productData.formDetails || this.form.formDetails) {
				controller.closeModal();
				clearTimeout(this.openModalTimeoutID);
				this.openModalTimeoutID = setTimeout(() => {
					controller.openModal({
						className: 'modal--sm',
						component: {
							name: 'v-details',
							props: {
								propProductData: this.productData,
								dataSource: this.productData.formDetails || this.form.formDetails
							}
						}
					});
				}, 250);
			}
		},

		openCustomsCalculator() {
			controller.closeModal();
			clearTimeout(this.openModalTimeoutID);
			this.openModalTimeoutID = setTimeout(() => {
				controller.openModal({
					className: 'modal--sm',
					btnBackDataSource: (this.productData && this.productData.formDetails || this.form.formDetails)
						? (this.productData.formDetails || this.form.formDetails)
						: null,
					component: {
						name: 'v-details',
						props: {
							propProductData: this.productData,
							view: "customs-calculator",
							dataSource: this.productData.customsCalculator
						}
					}
				});
			}, 250);
		},

		getFieldError(field) {
			if (this.form.errors && this.form.errors.fields) {
				let filteredErrors = this.form.errors.fields.filter((item) => item.name === field.name);
				return filteredErrors.length ? filteredErrors : null;
			} else {
				return null;
			}
		},

		scrollToFirstError() {
			if (!this) {
				return;
			}
			if (document.body.classList.contains('state--modal-open')) {
				return;
			}
			const $errorFields = this.$el.querySelectorAll('.form-error');
			if ($errorFields.length > 0) {
				const $firstErrorField = $errorFields[0];
				const yOffset = -10;
				const coordY = $firstErrorField.getBoundingClientRect().top + window.pageYOffset + yOffset;
				window.scrollTo({top: coordY, behavior: 'smooth'});
			} else {
				window.scrollTo({top: 0, behavior: 'smooth'});
			}
		},

		proxyFieldName(name) {
			return `state[form][${name}]`;
		},

		dataSet(data) {
			if (data.success && data.closeModal) {
				if (typeof modalController !== 'undefined') {
					if (typeof (data.modalTimeout) !== 'undefined' && data.modalTimeout > 0) {
						clearTimeout(this.modalTimeout);
						this.modalTimeout = setTimeout(() => {
							controller.closeModal();
						}, data.modalTimeout);
					} else {
						controller.closeModal();
					}
				}
				return;
			}
			if (data.modal) {
				window.modalController.closeAll();
				if (data.modal.type === 'form') {
					// открыть модальное окно с формой
					controller.openModal({
						className: 'modal--sm',
						component: {
							name: 'v-form',
							props: {
								dataSource: data.modal.url,
								productId: this.productData.id,
								media: data.modal.media,
								phones: data.modal.phones,
								className: 'call-back'
							}
						}
					});
				} else {
					// открыть модальное окно с сообщением об успешной отправке формы
					controller.openModal({
						className: data.modal.className,
						content: `<v-modal-window>${data.modal.content}</v-modal-window>`
					});
				}
			}
			if (data.success) {
				this.$emit('success');
			}
			if (data.emit_event) {
				controller.emitCustomEvent(data.emit_event);
			}
			this.form = data;
			if (this.form.productData) {
				this.productData = this.form.productData;
			} else if (this.propProductData) {
				this.productData = this.propProductData;
			}

			if (!this.form.fields) {
				return false;
			}

			let priceMinValue = this.form.fields.find(field => field.name === 'CAR_PRICE')?.value.min || 0;
			let priceMaxValue;
			let priceSelectValue = this.productData.currency ? this.productData.currency :
					(this.form.fields.find(field => field.name === 'CAR_PRICE')?.value.selectValue);
			if (this.productData.price) {
				priceMaxValue = this.productData.price;
			} else {
				priceMaxValue = this.form.fields.find(field => field.name === 'CAR_PRICE')?.value.max ||
					this.form.fields.find(field => field.name === 'CAR_PRICE')?.value.min;
			}
			this.productPriceValue = null;
			this.productPriceValue = {
				"min": priceMinValue,
				"max": priceMaxValue,
				"selectValue": priceSelectValue
			};

			let priceCustomsMinValue = this.form.fields.find(field => field.name === 'CAR_PRICE_CUSTOMS')?.value.min || 0;
			let priceCustomsMaxValue;
			let priceCustomsSelectValue = this.productData.currency ? this.productData.currency :
				(this.form.fields.find(field => field.name === 'CAR_PRICE_CUSTOMS')?.value.selectValue);
			const priceCustoms = this.productData.priceCustoms;
			if (typeof priceCustoms === 'object' && priceCustoms !== null && priceCustoms.current.value) {
				priceCustomsMaxValue = priceCustoms.current.value;
			}
			else if (priceCustoms !== null) {
				priceCustomsMaxValue = priceCustoms;
			}
			else {
				const customsField = this.form.fields.find(field => field.name === 'CAR_PRICE_CUSTOMS');
				priceCustomsMaxValue = customsField?.value.max || customsField?.value.min;
			}
			this.productPriceCustomsValue = null;
			this.productPriceCustomsValue = {
				"min": priceCustomsMinValue,
				"max": priceCustomsMaxValue,
				"selectValue": priceCustomsSelectValue
			};

			let engVolMinValue = this.form.fields.find(field => field.name === 'ENGINE_VOLUME')?.value.min || 0;
			let engVolMaxValue;
			if (this.productData.engineVolume) {
				engVolMaxValue = this.productData.engineVolume;
			} else {
				engVolMaxValue = this.form.fields.find(field => field.name === 'ENGINE_VOLUME')?.value.max ||
					this.form.fields.find(field => field.name === 'ENGINE_VOLUME')?.value.min;
			}
			this.engineVolumeValue = null;
			this.engineVolumeValue = {
				"min": engVolMinValue,
				"max": engVolMaxValue,
				"selectValue": null
			};

			this.countryValue = this.productData.country ? this.productData.country : (this.form.fields.find(field => field.name === 'COUNTRY')?.value || null);

			if (this.view === 'customs-calculator') {
				this.carAgeValue = this.productData.carAge ? this.productData.carAge : (this.form.fields.find(field => field.name === 'CAR_AGE')?.value || null);
			}

			if (this.view === 'customs-calculator') {
				this.carEngineValue = this.productData.carEngine ? this.productData.carEngine : (this.form.fields.find(field => field.name === 'CAR_ENGINE')?.value || null);
			}

			if (this.view === 'customs-calculator') {
				this.benefitValue = this.productData.benefit ? this.productData.benefit : (this.form.fields.find(field => field.name === 'BENEFIT')?.value || null);
			}

			if (this.productData.addOptions) {
				const fieldCurrencyOptions = [];
				const currencies = new Set();
				const collectCurrencies = (item) => {
					if (item.prices) {
						Object.keys(item.prices).forEach(currency => currencies.add(currency));
					}
					if (item.framed && Array.isArray(item.framed)) {
						item.framed.forEach(subItem => collectCurrencies(subItem));
					}
				};
				this.productData.addOptions.forEach(option => collectCurrencies(option));
				currencies.forEach(currency => {
					fieldCurrencyOptions.push({
						value: currency,
						text: currency
					});
				});
				this.fieldCurrency = {
					id: "FIELD_CURRENCY",
					name: "FIELD_CURRENCY",
					type: "tab-switch",
					value: this.productData.currency ? this.productData.currency : fieldCurrencyOptions[0].value,
					options: fieldCurrencyOptions
				}
			}
		},

		submit(options = {}) {
			let namesOfCurrentIteration = [];
			if (this.form && this.form.fields) {
				this.form.fields.forEach(field => {
					let key = this.proxyFieldName(field.name);
					if (field.multiple) {
						key = this.proxyFieldName(field.name.replace('[]', ''));
					}
					if (!field.value) {
						field.value = '';
					}
					if (field.type === 'file') {
						// очистка полей для файлов от старых значений
						for (let item of this.localFormData.entries()) {
							let isfoundInSavedFileKeys = false;
							for (let j = 0; j < this.savedFileKeys.length; j++) {
								if (item[0].indexOf(this.savedFileKeys[j]) > -1) {
									isfoundInSavedFileKeys = true;
									break;
								}
							}
							if (item[0].indexOf(key) === 0 && !isfoundInSavedFileKeys) {
								this.localFormData.delete(item[0]);
							}
						}
					} else if (namesOfCurrentIteration.indexOf(key) < 0) {
						// очистка всех остальных полей
						if (Array.isArray(field.value)) {
							field.options?.forEach((val, index) => {
								this.localFormData.delete(`${key}[${index}]`);
								namesOfCurrentIteration.push(`${key}[${index}]`);
							});
						} else {
							this.localFormData.delete(key);
							namesOfCurrentIteration.push(key);
						}
					}
					if (field.type === 'file') {
						// обработка файлов происходит в fileInput / fileRemove
						// здесь ничего делать не нужно
						/*
						 _.each(field.value, (fileListItem) => {
						 this.localFormData.append(field.name, fileListItem.file, fileListItem.name)
						 });
						 */
					} else {
						// для отправки файлов придется держать в памяти неизменный localFormData
						// перед отправкой нужно удалить старые значения из localFormData
						// т.к. localFormData.append добавляет новые значения к существующим
						// а localFormData.set не позволила бы работать с массивами типа NAME[]
						if (field.name === 'CAR_PRICE') {
							this.localFormData.append(key, JSON.stringify(this.productPriceValue));
						} else if (field.name === 'CAR_PRICE_CUSTOMS') {
							this.localFormData.append(key, JSON.stringify(this.productPriceCustomsValue));
						} else if (field.name === 'ENGINE_VOLUME') {
							this.localFormData.append(key, JSON.stringify(this.engineVolumeValue));
						} else if (field.name === 'CAR_AGE') {
							this.localFormData.append(key, this.carAgeValue);
						} else if (field.name === 'CAR_ENGINE') {
							this.localFormData.append(key, this.carEngineValue);
						} else if (field.name === 'BENEFIT') {
							this.localFormData.append(key, this.benefitValue);
						} else if (field.name === 'COUNTRY') {
							this.localFormData.append(key, this.countryValue);
						} else if (Array.isArray(field.value)) {
							field.value.forEach((val, index) => {
								this.localFormData.append(`${key}[${index}]`, val);
							});
						} else if ((typeof field.value === 'object') && (field.value !== null)) {
							this.localFormData.append(key, JSON.stringify(field.value));
						} else {
							this.localFormData.append(key, field.value);
						}
					}
				});
			}
			this.localFormData.set('state[action]', options.action || 'submit');
			this.localFormData.set('bxajaxid', this.bxajaxid);
			this.localFormData.set('productId', this.productData.id);
			this.localFormData.set('price', this.productData.price);
			this.localFormData.set('priceCustoms', this.productData.priceCustoms);
			this.localFormData.set('options', JSON.stringify(this.productData.options));
			this.localFormData.set('addOptions', JSON.stringify(this.productData.addOptions));
			this.localFormData.set('total', JSON.stringify(this.productData.total));
			this.localFormData.set('customsCalculator', this.productData.customsCalculator);
			this.localFormData.set('year', this.productData.year);
			this.localFormData.set('engineType', this.productData.engineType);
			this.localFormData.set('engineVolume', JSON.stringify(this.engineVolumeValue));
			this.localFormData.set('bid', this.productData.bid);
			this.localFormData.set('auctionType', this.productData.auctionType);
			this.localFormData.set('stateDelivery', this.productData.stateDelivery);
			this.localFormData.set('lemonService', JSON.stringify(this.productData.lemonService));
			this.localFormData.set('enginePower', this.productData.enginePower);
			this.localFormData.set('carAge', this.productData.carAge);
			this.localFormData.set('carEngine', this.productData.carEngine);
			this.localFormData.set('benefit', this.productData.benefit);
			this.localFormData.set('country', this.productData.country);
			if (this.confirmed) {
				this.localFormData.append('confirmed', 1);
			} else {
				this.localFormData.delete('confirmed');
			}
			this.dataLoad({
				url: this.form.remote,
				data: this.localFormData,
				delay: true
			});
		},

		fieldChanged(field) {
			if (field.autosubmit) {
				this.submit({action: 'autosubmit'});
			}
		},

		fileInput(field, e) {
			this.savedFileKeys = [];
			for (let i = 0; i < e.target.files.length; i++) {
				this.savedFileKeys.push(e.key);
				this.localFormData.append(this.proxyFieldName(field.name) + '[' + e.key + ']', e.target.files[i].path || e.target.files[i]);
			}

			if (field.autosubmit && !e.nosubmit) {
				this.submit({action: 'autosubmit'});
			}
		},

		fileRemove(field, e) {
			this.localFormData.delete(this.proxyFieldName(field.name) + '[' + e.key + ']');

			if (field.autosubmit && !e.nosubmit) {
				this.submit({action: 'autosubmit'});
			}
		},

		valueRemove(field, e) {
			// remove error of removed value
			if (field.errors && field.errors.length) {
				field.errors.splice(e, 1);
			}
		}
	}
};
</script>